import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAccountVesselScope } from '../../hooks/useAccountVesselScope';
import ListBase from '../../modules/mga/List';
import FormBase from '../../modules/mga/Form';
import Dashboard from '../../modules/mga/Dashboard';
import PeriodGrid from '../../modules/mga/PeriodGrid';
import Payslip from '../../modules/mga/Payslip';

export const List: React.FC = () => <ListBase />;

export const Form: React.FC = () => {
  const vesselId = useAccountVesselScope();
  if (vesselId == null) return <Navigate to="/login" replace />;
  return <FormBase lockedVesselId={vesselId} />;
};

export { Dashboard, PeriodGrid, Payslip };
